import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import ValidationResults from "./ValidationResults";

interface StepValidationProps {
  validation: {
    invalid_rows: number;
  };
  onContinue: () => void;
  uploading: boolean;
}

export const StepValidation: React.FC<StepValidationProps> = ({
  validation,
  onContinue,
  uploading,
}) => (
  <Box>
    {uploading && (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 4, gap: 2 }}>
        <CircularProgress size={24} />
        <Typography>Processing validation results...</Typography>
      </Box>
    )}

    {!uploading && <ValidationResults validation={validation} />}
  </Box>
);